import React from 'react';

const Terms = () => {
  return (
    <div className="fade-in" style={{ maxWidth: '900px', margin: '0 auto' }}>
      <h1 style={{ fontSize: '32px', fontWeight: '800', marginBottom: '24px' }}>
        Terms of Service
      </h1>
      <p style={{ color: 'var(--text-muted)', marginBottom: '30px' }}>
        Last updated: February 12, 2026
      </p>

      <div className="card" style={{ padding: '40px' }}>
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>
            1. Acceptance of Terms
          </h2>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8' }}>
            By accessing or using Addison Mail, you agree to be bound by these Terms of Service. 
            If you disagree with any part of the terms, you may not access the service.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>
            2. Description of Service
          </h2>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8' }}>
            Addison Mail provides secure email services including:
          </p>
          <ul style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginLeft: '20px', marginTop: '12px' }}>
            <li>Encrypted email sending and receiving</li>
            <li>Temporary email aliases</li>
            <li>PGP key management</li>
            <li>API access for developers</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>
            3. Account Registration
          </h2>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginBottom: '12px' }}>
            To use Addison Mail, you must:
          </p>
          <ul style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginLeft: '20px' }}>
            <li>Be at least 13 years old</li>
            <li>Provide accurate and complete information</li>
            <li>Maintain the security of your account</li>
            <li>Not share your account credentials</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>
            4. Acceptable Use
          </h2>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginBottom: '12px' }}>
            You agree NOT to use Addison Mail for:
          </p>
          <ul style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginLeft: '20px' }}>
            <li>Illegal activities or content</li>
            <li>Spam, phishing, or malware distribution</li>
            <li>Harassment or abuse of others</li>
            <li>Circumventing security measures</li>
            <li>Violating intellectual property rights</li>
            <li>Crypto scams or fraud</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>
            5. Subscription & Payments
          </h2>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginBottom: '12px' }}>
            <strong>Free Tier:</strong> Limited features available at no cost.
          </p>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginBottom: '12px' }}>
            <strong>Paid Plans:</strong> Billed monthly or annually. You may cancel at any time.
          </p>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8' }}>
            <strong>Refunds:</strong> Pro-rated refunds available within 14 days of purchase.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>
            6. Service Limitations
          </h2>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginBottom: '12px' }}>
            We strive for 99.9% uptime but do not guarantee uninterrupted service. 
            We reserve the right to:
          </p>
          <ul style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginLeft: '20px' }}>
            <li>Modify or discontinue features with notice</li>
            <li>Enforce usage limits to prevent abuse</li>
            <li>Suspend accounts violating these terms</li>
            <li>Delete temporary mail after expiration</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>
            7. Data Ownership
          </h2>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8' }}>
            You retain ownership of your emails and data. We claim no rights to your content. 
            You grant us only the necessary permissions to provide the service (store, transmit, display).
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>
            8. Termination
          </h2>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8' }}>
            You may delete your account at any time. Upon termination, we will delete your data 
            within 30 days, except where required by law to retain it.
          </p>
        </section>

        <section>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>
            9. Contact
          </h2>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.8' }}>
            Questions about these terms? Contact us at{' '}
            <a href="mailto:legal@addisonelectronique.com" style={{ color: '#DC2626' }}>
              legal@addisonelectronique.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms;

